export const ko = {
  ADD_COLOR_STRING_KEY: '색깔 추가',
  ADD_TEXT_KEY: '텍스트 추가',
  ADD_TO_ORDER_KEY: '주문에 추가',
  ADD_TO_CART: '장바구니에 추가',
  ADD_TEMPLATE: '템플릿 추가',
  ADJUST_SIZE_KEY: '사이즈 조정',
  ADJUST_TRANSPARENCY_KEY: '투명도 조정',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    '완료를 클릭하여 HP 약관과 개인정보보호정책에 동의하십시오.',
  ALIGN_BOTTOM_KEY: '아래쪽 정렬',
  ALIGN_CENTER_KEY: '중심 정렬',
  ALIGN_KEY: '정렬하다',
  ALIGN_LEFT_KEY: '시작',
  ALIGN_MIDDLE_KEY: '중간 정렬',
  ALIGN_RIGHT_KEY: '끝',
  ALIGN_TOP_KEY: '정렬',
  ALL_TAB_TITLE_KEY: '모두',
  ALMOST_DONE_TITLE_KEY: '거의 끝났습니다!',
  AND_KEY: '및',
  APPLY_KEY: '적용',
  AREA_CODE: '지역 코드',
  BASIC_HELPER_INSTRUCTION1_KEY:
    '콘텐츠를 검색하고 디자인에 맞는 이미지를 선택하거나 자체 이미지를 업로드하십시오',
  BASIC_HELPER_INSTRUCTION2_KEY:
    '디자인을 미리 보거나 세부 사항을 조정하십시오',
  BASIC_HELPER_INSTRUCTION3_KEY:
    '디자인을 사용자 지정하고 프로젝트에 다른 요소를 추가하십시오',
  BASIC_HELPER_INSTRUCTION4_KEY:
    '디자인이 준비되면 다음을 클릭하여 마지막으로 확인하고 주문하십시오.',
  BACK_KEY: '뒤로',
  BACKGROUND_KEY: '배경',
  BACKGROUND_UPPER_CASE_KEY: '배경',
  BACKGROUND_CONTRAST_KEY: '배경 대비',
  BLANK_INSPIRATION_CATEGORY_KEY: '이 범주에서 감흥은 없습니다.',
  BRING_TO_FRONT_KEY: '맨 앞으로 가져오기',
  CANCEL_TEXT_KEY: ' 취소 ',
  CENTIMETERS_KEY: '센티미터',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: '프로젝트 설정 변경',
  CHECKBOX_CONTENT1: '패턴 디자인 © 뉴스 레터를 받고 싶습니다.',
  CHECKBOX_CONTENT2:
    'HP가 패턴 디자인 © 서비스를 대신하여 계정을 만들도록 HP에 위임합니다',
  CHOOSE_FROM_COMPUTER_KEY: '컴퓨터에서 선택하십시오',
  CHOOSE_RIP_OPTIONS: '호환되는 제3자 RIP 중 하나를 선택하십시오',
  CHOOSE_FILE_KEY: '파일 선택',
  CITY: '시티',
  CLEAR_ALL_KEY: '모두 지우기',
  CLEAR_COLOR_KEY: '색깔 지우기',
  CLOSE_WINDOW_KEY: '창 닫기',
  CLEAR_ALL_OBJECTS: '모든 개체 지우기',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: '배경에서 모든 개체가 제거됩니다.',
  CLEAR_DESIGN_KEY: '디자인 지우기',
  COLOR_KEY: '색깔',
  CONTINUE_KEY: '계속...',
  COMPANY: '회사',
  CONGRATULATIONS_KEY: '축하합니다!',
  CONFIRM_PASSWORD: '비밀번호 확인',
  CONFIRM_PATTERN_ACCOUNT_KEY: 'Pattern Design 계정이 없습니까?',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: '아직 Vecteezy 계정이 없습니까?',
  COUNTRY: '국가',
  CREATE_ACCOUNT: '계정 만들기',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: '사용자 지정',
  CUSTOM_PRICE_SIGN_IN_KEY:
    '다음 단계에서 로그인하고 사용자 지정 가격을 알아보십시오.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: '새로 만들기',
  DESIGN_KEY: '디자인',
  DELETE_KEY: '삭제',
  DOCUMENT_COLORS: '문서 색상',
  DONE: '완료!',
  DONE_KEY: '완료',
  DONT_SHOW_ALERT_KEY: '다시 보지 않기',
  DOWNLOAD_COLUMN_HEADER_KEY: '다운로드',
  DOWNLOAD_APP_TITLE_KEY: '여기서 앱을 다운로드할 수 있습니다:',
  DOWNLOAD_LINK_KEY: '여기서 HP Click을 무료로 다운로드하십시오',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'HP SmartStream 다운로드',
  DOWNLOAD_INSTR_KEY: 'HP Click을 설치한 후 계속하십시오',
  DOWNLOAD_SMARTSTREAM_KEY: 'HP SmartStream 다운로드',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox 가져오기',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    '이미지 크기는 1 GB 미만이어야 합니다. pdf, png, jpg, svg, tiff 포맷만 지원합니다.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime 검색',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime 이미지',
  DUPLICATE_KEY: '복사',
  EACH_ITEM_PRICE_KEY:
    '디자인에 고급 콘텐츠 제공자의 콘텐츠가 포함되어 있습니다. 각 요소별 가격은 다음과 같습니다.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: '디자인 편집',
  EDIT_LOWERCASE_KEY: '편집',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    '죄송합니다. 오류가 발생했습니다. 나중에 다시 시도하십시오.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    '이런, 업로드된 PDF 파일을 여는 중 오류가 발생했습니다.',
  EMAIL_KEY: '이메일',
  EMAIL_ADDRESS_KEY: '이메일 주소:',
  EMAIL_CHECKBOX_MESSAGE:
    '이 고객은 귀하나 서비스 제공자를 대신하여 HP가 보낸 이메일을 받게 될 것이라는 것을 이해하고 있습니다.',
  EXTRA_INFO_KEY: '추가 정보',
  EMAIL_NOTIFICATION: '곧 이메일이 발송됩니다. 최대 15분이 소요될 수 있습니다.',
  EMAIL_DIALOG_MESSAGE: '디자인을 공유할 사람의 이메일 주소를 입력하십시오.',
  ENTER_KEY: '입력',
  EXISTING_FOLDER_KEY: '기존 폴더',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    '모든 선택 항목이 올바른지 확인 후 체크아웃하십시오',
  FINAL_CHECK_TITLE_KEY: '최종 검토',
  FINISH_KEY: '완료',
  FINISH_LATER_KEY: '나중에 완료',
  FIRSTNAME: '이름',
  FISCAL_NUM: '회계 번호',
  FLIP_KEY: '대칭 이동',
  FOR_KEY: '...에 대한',
  FORGOT_PASSWORD_KEY: '비밀번호를 잊었습니까?',
  FOTOLIA_KEYWORDS_KEY: '키워드:',
  FOLDER_NAME: '폴더 이름',
  FOLDER_NAME_KEY: '폴더 이름:',
  FOLDER_ALREADY_EXIST_KEY: '이미 존재하는 폴더 이름입니다',
  FREE_POSTER_COMPLETE_MESSAGE_KEY: '무료 포스터 디자인을 완료했습니다',
  FREE_VECTOR_GRAPHICS_KEY: '무료 벡터 그래픽',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: '알겠습니다',
  GROUP_ALL_KEY: '모두 그룹으로 묶기',
  GROUP_SCALE: '일괄 비율 조정',
  GIFT_WRAPS_KEY: '선물 포장',
  GIVE_PROJECT_NAME_KEY: '프로젝트 이름을 입력하십시오',
  HEIGHT_KEY: '높이',
  TOUR_DESCRIPTION_TEXT:
    '디자인 과정을 소개하겠습니다. 언제라도 도움말 아이콘을 클릭하여 둘러보기를 다시 열 수 있습니다.',
  HELP_KEY: '도움말',
  HELPER_TITLE_KEY_1:
    '빈 페이지 또는 수백만 개의 이미지와 텍스트에서 포스터 디자인을 만듭니다. 로컬 드라이브, Dropbox 또는 소셜 미디어에서 자신의 콘텐츠 업로드',
  HELPER_TITLE_KEY_3: '한 곳에서 모든 디자인 작업보기',
  HELPER_TITLE_KEY_4: 'Next를 클릭하여 최종 디자인을 미리보고 완성하십시오.',
  HERE_KEY: '여기',
  HELP_IMPROVE_KEY:
    '생산성과 작업자 효율을 개선하고 컬러 생산으로 확장하십시오.',
  HIGH_QUALITY_KEY: '고품질',
  IMAGES_TITLE_KEY: '이미지',
  IMPERIAL_KEY: '장엄한',
  IMPORTING_KEY: '가져오기',
  INCHES_COLUMN_HEADER_KEY: '인치',
  INCHES_KEY: ' 인치',
  INCHES_UNIT_STRING_KEY: 'in.',
  INVALID_EMAIL_ADDRESS_KEY: '잘못된 이메일 주소',
  INVALID_INFO_KEY: '세부 정보를 입력하십시오.',
  INVALID_NAME_KEY: '잘못된 이름',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    '죄송합니다. 선택하신 파일이 너무 큽니다. 파일의 최대 크기는 500mb입니다.',
  INSUFFICIENT_CREDITS_KEY: '크레딧 부족',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: '영감',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    '이런, 파일 포맷이 옳지 않습니다. pdf, jpg, png, svg, tif 파일만 처리할 수 있습니다.',
  LANDSCAPE_KEY: '가로',
  LANGUAGE_LABLE_KEY: '언어',
  LASTNAME: '성',
  LEARN_MORE: '자세한 정보',
  LEARN_THE_BASICS_KEY: '기본 사항을 학습하십시오',
  LEGAL_FOOTER_MESSAGE1_KEY:
    '귀하는 이 사이트를 사용함으로써 이들에게 구속됩니다',
  LEGAL_FOOTER_MESSAGE2_KEY: '본 웹사이트는 준수합니다',
  LEGAL_FOOTER_MESSAGE3_KEY: '및',
  LENGTH_STRING_IN_INCHES_KEY: 'in',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: '변경',
  LINK_READER_APP_KEY: 'LinkReader 앱',
  LINK_READER_APP_DESCRIPTION_KEY:
    '추가하려는 콘텐츠를 시각화하려면 LinkReader 앱을 다운로드하십시오.',
  LOADING_KEY: '로드 중...',
  LOADING_TEMPLATE_KEY: '템플릿로드 중',
  LOGIN_NOW: '지금 로그인',
  LOCK_KEY: '잠금',
  LOGIN_KEY: '로그인',
  LOGIN_PATTERN_DESIGN_KEY: 'Pattern design에 로그인',
  LOGIN_SUBTITLE_KEY: '로그인하여 사용자 지정 가격과 결제 정보를 알아보십시오',
  LOGIN_VECTEEZY_KEY: 'Vecteezy에 로그인',
  LOGIN_DREAMSTIME_KEY: 'Dreamstime에 로그인 ',
  LOGOUT_KEY: '로그아웃',
  MATERIAL_TITLE_KEY: '재료',
  MATERIAL_STRING_KEY: '재료',
  MEASUREMENT_KEY: '측정',
  METRIC_KEY: '메트릭',
  MOBILE: '변하기 쉬운',
  MODEL_TITLE_KEY: '모델',
  MORE_INFO_TEXT_KEY: '자세히',
  MY_GIFTWRAPS_KEY: '내 선물 포장',
  MY_WORK_KEY: '내 작업',
  MY_WORK_SAVE_KEY: '디자인이 내 작업 공간에 저장되었습니다.',
  NAME_KEY: '이름:',
  NEXT_BUTTON_TITLE_KEY: '다음',
  NEW_FOLDER_KEY: '새 폴더',
  NO_SHADOW_KEY: '그림자 없음',
  OBJECT_QUANTITY_KEY: '수량',
  OBJECTS_UPPER_CASE_KEY: '개체',
  OK_KEY: '확인',
  ORDER_SAMPLE_KEY: '샘플 주문',
  ORDER_SAMPLE: '샘플 주문',
  ORDER_SAMPLE_INFOLABEL_1: '샘플로 주문할 이미지를 선택하십시오',
  ORDER_SAMPLE_INFOLABEL_2:
    '실제 사이즈의 프로젝트에 대한 클로즈업 보기를 이메일로 받게 됩니다',
  ORDER_SAMPLE_INFOLABEL_3: '품질과 해상도를 평가하는 데 도움이 됩니다',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: '지금 샘플 주문',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    '실제 사이즈의 프로젝트 클로즈업 보기를 담은 이메일을 받고 품질/해상도를 평가하십시오.',
  ORIENTATION_KEY: '방향',
  OTHER_PRINTING_OPTIONS: '기타 인쇄 옵션',
  PASSWORD_KEY: '비밀번호',
  PATTERN_COLOR_KEY: '패턴 색깔',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: '패턴',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'pdf를 만들지 못했습니다. 다시 시도하십시오.',
  PHOTOS_KEY: '사진',
  PHOTO: '사진',
  PHONE: '전화',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    '본인은 본 이미지의 저작권자이며 다음에 동의합니다.',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    '이미지 사이즈는 500 MB 미만이어야 합니다. png, jpg, tiff, svg, pdf 포맷만 지원합니다.',
  PIXEL_COLUMN_HEADER_KEY: '픽셀',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: '여기에 텍스트를 입력하십시오 ...',
  PLACEHOLDER_EXTRA_INFO_KEY: '즉, 인쇄 업체에 전달해야 할 중요 정보',
  PLACEHOLDER_INCHES_STRING_KEY: 'in',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: '내 포스터',
  PORTRAIT_KEY: '세로',
  POSITION: '배치',
  PREMIUM_IMAGES_TITLE_KEY: '고급 이미지:',
  PRE_CHECK_SAVE_DIALOG_TITLE: '프로젝트를 저장하십시오',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    '프로젝트가 변경되어 계속하려면 저장해야 합니다.',
  PRICE_COLUMN_HEADER_KEY: '가격',
  PRINTER_SERIAL_NUMBER_KEY: '프린터 일련 번호*',
  PRINTING_ENABLE_DETAILS_KEY: '인쇄하려면 몇 가지 정보가 더 필요합니다',
  PRINTER_MODELS_KEY: '프린터 모델*',
  PROCESSING_KEY: '처리 중...',
  PROCESSING_ALERT_TXT: '디자인을 처리하는 동안 이 창을 닫지 마십시오',
  PROCESSING_ALERT_TXT2:
    '처리가 완료되면 HP Click이 자동으로 열려 파일을 다운로드합니다',
  PROCESSING_DONE: '거의 다 됐습니다!',
  PROCESSING_FILE_TXT: '파일을 처리 중입니다.',
  PROCESSING_TIME_TXT:
    '최고의 작업 이미지 품질을 제공하기 위해 시간이 걸릴 수 있습니다',
  PROCESSING_ALERT_TXT3: 'PDF가 컴퓨터에 자동 다운로드됩니다',
  PROCESSING_ALERT_TXT4: '설정에서 JDF 연결을 구성하여 자동 처리할 수 있습니다',
  PREMIUM_CONTENT_KEY: '고급 콘텐츠',
  PREVIEW_KEY: '미리 보기',
  PROFESSIONAL_USE_TITLE_KEY: '전문가용.',
  PROJECT_NAME_KEY: '프로젝트 이름',
  PROJECT_NAME: '프로젝트 이름:',
  PROJECT_ALREADY_EXIST_KEY: '이미 존재하는 프로젝트 이름입니다',
  NONUNIQUE_PROJECT_NAME_MESSAGE: '이미 존재하는 프로젝트 이름입니다',
  NONUNIQUE_FOLDER_NAME_MESSAGE: '이미 존재하는 폴더 이름입니다',
  PIXELATION_WARNING_KEY: '모자이크 경고',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    '업로드 한 사진의 해상도로 인해 피부가 왜곡되거나 왜곡 될 수 있습니다. 흐릿함이 없도록하려면 좋은 품질의 이미지를 업로드하고 이미지가 늘어나지 않도록하십시오. 미리보기에 만족하고 계속하려면 계속 제출해주세요.',
  REGISTER_CONTACTINFO: '연락처 정보',
  REGISTER_INFO: '등록 정보',
  REGISTER_PATTERNSUB1: 'HP 고객의 가치로서,',
  REQUIRED_FIELDS_KEY: '필수 필드',
  REQUIRED_FIELDS_TEXT_KEY: '필수 필드',
  REQUIRED_STRING_KEY: '필수',
  RECOLOR_KEY: '다시 칠하기',
  RADICALLY_SIMPLE_KEY: '매우 간편한 인쇄 소프트웨어',
  RIPSELECTION_HEAD:
    '첫 작업입니다. 선호하는 호환 인쇄 소프트웨어를 선택하십시오',
  RIPSELECTION_DESC:
    '선택 사항은 향후 출력 시 기본 인쇄 옵션이 됩니다. 나중에 설정에서 변경할 수 있습니다',
  REGISTER_COMPANYINFO: '회사 정보',
  REGISTER_KEY: '등록',
  REGISTER_NOW: '지금 등록',
  REOLOR_KEY: '다시 칠하기',
  REQUEST_SAMPLE_KEY: '샘플 요청',
  RESIZE_KEY: '사이즈 조정',
  RESIZE_ARBITRARILY_KEY: '임의로 사이즈 변경',
  RESIZE_PROPORTIONALLY_KEY: '비율에 따라 사이즈 변경',
  REVIEW_AND_SUBMIT_KEY: '검토 및 제출',
  REQUEST_FOR_QUOTATION: '견적 요청',
  RIGHT_LOGO_TEXT_KEY: '제공',
  ROTATE_KEY: '회전',
  ROTATE_LEFT_KEY: '왼쪽으로 90° 회전',
  ROTATE_RIGHT_KEY: '오른쪽으로 90° 회전',
  ROTATION_KEY: '회전',
  ROWS_COLUMN_LABEL_STRING_KEY: '행 및 열',
  ROYALTY_FREE_KEY: '로열티 없음',
  ROYALTY_KEY: '왕족',
  SALUTATION: '인사말',
  SAVE_KEY: '저장',
  SAVING_KEY: '저장 중...',
  SAVE_INSPIRATION: '영감 저장',
  SAVE_TEMPLATE: '템플릿 저장',
  SAVE_DIALOG_TITLE: '프로젝트를 저장하십시오',
  SAVE_PROJECT_NAME_KEY: '먼저 프로젝트를 저장하십시오',
  SAVEDIALOG_MESSAGE:
    '프로젝트를 저장하려면 로그인하십시오.계정이 없으면 간편하게 만들 수 있습니다. 진행 사항이 사라지지 않습니다.',
  SEAMLESS_KEY: '완벽한',
  SCALE_INFO_STRING_KEY: '이미지를 디자인 크기에 맞게 조정하십시오',
  SCALE_KEY: '크기 조정',
  SCALE_ALL_KEY: '모두 크기 조정',
  SCALE_TO_FILL_KEY: '채우기',
  SEARCH_BUTTON_TITLE_KEY: '검색',
  SELECT_CUSTOM_SIZE_KEY: '사용자 지정 사이즈를 선택하십시오',
  SELECT_CUSTOM_KEY: '사용자 지정',
  SEARCH_TITLE: '검색',
  SELECTED_IMAGE_KEY: '선택된 이미지:',
  SELECT_GIFT_WRAPS_SIZE_KEY: '선물 포장 선택 크기',
  SELECT_COUNTRY: '국가 선택',
  SELECT_SALUTATION: '---고르다---',
  SELECT_POSTER_SIZE_KEY: '포스터 사이즈를 선택하십시오',
  SELECT_PRINTING_OPTION_KEY: '선호하는 인쇄 옵션을 선택하십시오',
  SEND_INSTALLATION_INSTRUCTION_KEY: '설치 지침을 보내주십시오',
  SEND_TO_BACK_KEY: '뒤로 보내기',
  SEND_KEY: '보내기',
  SEND_TO_PRINT_TITLE_KEY: '발송하여 인쇄하기',
  SET_SIZE_KEY: '사이즈 설정',
  SETTINGS_KEY: '설정',
  SETTINGS_UPPERCASE_KEY: '설정',
  SHARE_KEY: '공유',
  SIGNED_IN_AS_KEY: '로그인 사용자',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    '로그인하거나 등록하여 사용자 지정 가격과 결제 정보를 알아보십시오',
  SIGN_UP_NOW_KEY: '지금 등록하세요',
  SKIP_KEY: '건너뛰기',
  SOLID_COLORS_KEY: '단색',
  SQFT_UNIT_STRING_KEY: 'sq. ft.',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: '둘러보기 시작',
  STATUS_MSG: '파일을 인쇄하기 위해 발송됐습니다!',
  SUBMIT_BUTTON_KEY: '제출하다',
  SHARE_LINK_LABEL: '공유하려는 링크 유형을 선택하십시오',
  SHARE_EDIT_LINK: '링크 편집',
  SHARE_VIEW_LINK: '링크 보기',
  SHARE_YOUR_CREATION: '작품을 공유하십시오!',
  STREET_ADD: '거리 주소',
  TARGET_VIEWING_HINT: '* 설정에서 대상 보기 거리를 변경할 수 있습니다.',
  TERMS1_KEY: '약관',
  TERMS2_KEY: 'HP 개인정보보호정책',
  TERMS3_KEY: 'HP 개인 데이터 권리 공지',
  TERMS_OF_USE_KEY: '약관',
  TERMS_OF_USE: '이용 약관',
  TEXT_SHADOW_COLOR_KEY: '텍스트 그림자 색깔',
  TEXT_ANCHOR_MIDDLE: '중간',
  TEXT_UPPERCASE_KEY: '본문',
  TILE_KEY: '타일',
  TOTAL_KEY: '합계',
  TOTAL_PRICE_KEY: '합계:',
  TRANSPARENCY_KEY: '투명도',
  TEMPLATES_KEY: '템플릿',
  TEMPLATES_UPPER_CASE_KEY: '템플레이트',
  THANK_YOU_KEY: '고맙습니다',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: '잠금 해제',
  UNGROUP_KEY: '그룹 해제',
  UPDATE_TEXT_KEY: '업데이트',
  UPLOAD_KEY: '업로드',
  UPLOAD_LOGO_KEY: '로고 업로드',
  UPLOAD_IMAGE_KEY: '이미지를 업로드하십시오',
  UPLOAD_UPPERCASE_KEY: '업로드',
  USER_NAME: '사용자 이름',
  USER_TYPE_TITLE_KEY: '사용자 유형*',
  UNTILE_KEY: '타일 취소',
  UNSPLASH_SEARCH_TITLE: 'Unsplash 검색',
  VALIDITY_KEY: '유효성',
  VANILLA_LOGIN_DIALOG_KEY:
    '무료로 가입하고 디자인을 저장 및 인쇄하고 저장한 작업을 보십시오',
  VANILLA_PREVIEW_MESSAGE_KEY:
    '디자인 미리 보기입니다. 최종 디자인을 확인한 후 진행하거나 편집을 선택하여 변경하십시오',
  VAT_KEY: '부가가치세',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: '벡터',
  VIEW_FOTOLIA_KEY: 'Fotolia©에서 보기',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: '디자인 상세 정보 보기',
  VIEW_DESIGNER_PROFILE_KEY: '디자이너 프로필 보기',
  VIEW_PRICE_KEY: '가격 보기',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy 검색',
  WALL_POSTER_KEY: '포스터',
  WALL_SIZE_TEXT_KEY: '벽 사이즈',
  WARNING_KEY: '경고',
  WEBSITE: '웹 사이트',
  WIDTH_KEY: '너비',
  YOU_CAN_ALWAYS_ACCESS: '언제라도 디자인을 액세스할 수 있습니다 ',
  YOUR_NAME_KEY: '이름',
  YOUR_SELECTION_WILL_KEY: '선택 사항은 향후 출력 시 기본 인쇄 경로가 됩니다.',
  YOUR_PROJECT_KEY: '프로젝트:',
  PROJECT_NAME_ERROR_TEXT: '프로젝트의 이름을 입력하십시오.',
  PROJECT_FOLDER_ERROR_TEXT: '프로젝트 폴더의 이름을 입력하십시오.',
  PIXELATION_WARNING_SETTINGS_KEY: '모자이크 경고 설정',
  MINIMUM_VIEWING_DISTANCE_KEY: '최소 보기 거리',
  BACKGROUND_UPLOAD_KEY: '배경',
  OBJECT_UPLOAD_KEY: '개체',
  PHOTO_UPLOAD_KEY: '사진',
  NO_DREAMSTIME_ERROR_MESSAGE: '꿈이없는 콘텐츠가 발견되었습니다.',
  NO_ELEMENT_ERROR_MESSAGE: '요소를 찾을 수 없습니다.',
  NO_MORE_IMAGES_FOUND_KEY: '더 이상 이미지를 찾을 수 없습니다',
  NO_PATTERN_ERROR_MESSAGE: '패턴을 찾을 수 없습니다.',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: '이미 {0} 계정?',
  CHANGE_MEASURING_SYSTEM_KEY: '{0}(으)로 변경',
  DOWNLOADS_KEY: '{0} 다운로드 수',
  HEX_COLOR_KEY: '16 진수 색상: {0}',
  NEAR_KEY: '가까운',
  FAR_KEY: '멀리',
  CLOSE_UP_KEY: '닫다',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    '사용하려는 이미지가 사용중인 디자인 영역보다 작거나 큽니다.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    '더 나은 결과를 얻으려면 999 해상도의 이미지를 사용하십시오.',
  MESSAGE_KEY: '메시지:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    '이것은 디자인에 포함된 고급 콘텐츠의 가격 요약입니다. {0} 완료를 선택하여 콘텐츠 제공자가 다음 비용을 청구하는 것에 동의하십시오.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} 기본 인쇄 옵션입니다',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' 100 달러 상당의 고해상도 이미지를 재생산합니다 {0} 모든 창의적인 요구를 돕기 위해!',
  REGISTER_PATTERNSUB3:
    '오늘 가입하고 다음 30 일 동안 2500 만 장의 사진 기반 콘텐츠 파일에서 광고 소재 파일을 다운로드하고 {0} 창의적인 요구 사항을 충족시키는 데 도움을 줄 수 있습니다.',
  ZOOM_WARNING_PIXELATED_TEXT:
    '{0} {1}에서 볼 때 인쇄 이미지가 모자이크로 보이는 지점까지 확대했습니다* (현재 인쇄 해상도: {2}dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    '권장 보기 거리는 {0} {1}입니다. 이 거리에서 볼 수 없는 경우 이미지 비율이나 벽 사이즈를 줄이십시오.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    '권장 최소 이미지 사이즈는 {0} x {1} 픽셀입니다.',
  UPLOAD_STATUS: '{0}% / {1}MB',
  REGISTER_TO: '에 등록 {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: '최소 크기는 {0} (w) x {1} (h)입니다.',
  MINIMUM_HEIGHT_KEY: '최소 높이는 {0}입니다.',
  MINIMUM_WIDTH_KEY: '최소 폭은 {0}입니다.',
  MAXIMUM_DIMENSIONS_KEY: '최대 크기는 {0} (w) x {1} (h)입니다.',
  MAXIMUM_WIDTH_KEY: '최대 폭은 {0}입니다.',
  MAXIMUM_HEIGHT_KEY: '최대 높이는 {0} %@입니다.',
  INVALID_NUMBER_ERROR_TEXT_KEY: '1 이상의 숫자를 입력하십시오.',
  PROCESSING_FAILED: '처리하지 못했습니다. 나중에 다시 시도하십시오',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    '죄송합니다. 여러 페이지로 구성된 PDF는 지원하지 않습니다.',
  MINIMUM_ZOOM_WARNING:
    '벽을 덮는 데 필요한 최소 높이 또는 폭에 도달했기 때문에 이 배경을 더 이상 축소할 수 없습니다.',
  OF_KEY: '의',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    '죄송합니다. 암호화 된 PDF는 지원되지 않습니다.',
  DROPBOX_UPLOAD_PROGRESS_KEY: '{0} / {1} 파일 가져오기',
  RECOLORING_KEY: '다시 칠하는 중...',
  TEXT_COLOR_KEY: '텍스트 색깔',
  SOLID_COLOR_KEY: '단색',
  MATERIAL_CHOICE_APPLIED: '재료 선택이 적용되었습니다.',
  AUTHENTICATE_DIALOG_TITLE: '이 콘텐츠 소스는 비밀번호로 보호되어 있습니다',
  AUTHENTICATE_FAILED_MESSAGE: '인증 실패!',
  DROPBOX_IMPORT_ERROR_HEADER: '파일을 가져오는 데 문제가 발생했습니다',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  INSPIRATION_SIZE_CHANGE_WARNING:
    '이 영감 템플릿은 {0} X {1} {2}의 기본 크기와 함께 제공됩니다. 이 템플릿에 맞게 페이지 크기가 자동으로 변경됩니다.',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: '프로젝트',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: '노트북 선택',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: '이름',
  LAST_NAME_KEY: '성',
  PHONE_NUMBER_KEY: '전화 번호.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: '유효하지 않은 전화 번호',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: '필수 입력란을 입력하십시오.',
  ADDRESS_KEY: '주소',
  INVALID_ADDRESS_KEY: '잘못된 주소',
  CITY_KEY: '시티',
  INVALID_CITY_KEY: '도시가 잘못되었습니다.',
  COUNTRY_KEY: '국가',
  STATE_KEY: '상태',
  ZIP_KEY: '지퍼',
  INVALID_ZIP_KEY: '우편 번호가 잘못되었습니다.',
  ORDER_NUMBER: '주문 번호',
  YOUR_DETAILS_KEY: '세부 정보',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: '주의:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'PC 스킨을 자신에게 완벽하게 맞추려면 송장에 표시된대로 구매에 해당하는 정확한 모델을 선택해야합니다.',
  RESTART_PROJECT_ALERT_TITLE: '프로젝트를 다시 시작 하시겠습니까?',
  DISCARD_ALERT_MESSAGE: '현재 프로젝트가 폐기됩니다',
  RESTART: '재시작',
  BLOCKCHAIN_STRING: '블록 체인',
  CERTIFICATE_STRING: '~의 증명서',
  AUTHENTICITY_STRING: '확실성',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: '페이지 크기 경고!',
  MODIFY_SIZE_WARNING:
    '이 디자인의 크기를 조정하려면 "설정"탭에서 수행 할 수 있습니다. 디자인 요소는 원하는 치수에 맞게 편집해야 할 수도 있습니다.',
  RANDOMIZE_KEY: '무작위 화',
  PLEASE_WAIT: '기다려주세요',
  PROTECTING_YOUR_DATA: '데이터 보호...',
  SEARCH_YOUR_LAPTOP_KEY: '노트북 검색', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    '죄송합니다! 검색 할 노트북을 찾을 수 없습니다.', // Google translated
  SERIAL_NUMBER_KEY: '일련 번호',
  LOCKED_PROJECT: '잠긴 프로젝트',
  LOCKED_MESSAGE:
    '이 프로젝트는 주문되어 변경할 수 없습니다. 이 프로젝트는 볼 수만 있습니다.',
  EXPIRED_PROJECT: '만료된 프로젝트',
  EXPIRED_MESSAGE: '이 프로젝트는 만료됐습니다.',
  DELETED_PROJECT: '삭제된 프로젝트',
  DELETED_MESSAGE: '이 프로젝트는 삭제됐습니다.',
  CHOOSE_GROUP_TYPE: '고르다 {0} 유형',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: '1 이상의 숫자를 입력하십시오.',
  SIZE_KEY: '사이즈',
  DISTANCE_FROM_KEY: '거리 원점:',
  MYROOM_UPPERCASE_KEY: '내 방',
  FURNITURE_KEY: '가구',
  FIXTURES_KEY: '고정물',
  ADD_A_WALL_KEY: '벽을 추가하십시오',
  SELECT_A_WALL_KEY: '벽을 선택하십시오',
  LEFT_KEY: '왼쪽',
  RIGHT_KEY: '오른쪽',
  DELETE_WALL_KEY: '벽 삭제',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: '캔버스 유형을 선택하십시오',
  MAXIMUM_WALL_SIZE_KEY: '최대 벽 사이즈는 {0} sq.{1}입니다.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: '캔버스 높이가 벽 높이보다 큽니다.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: '캔버스 폭이 벽 폭보다 큽니다.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY: '현재 폭에 대한 최대 열 개수는 {0}입니다',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    '현재 높이에 대한 최대 행 개수는 is {1}입니다',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    '벽 폭이 캔버스 폭보다 작습니다.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: '벽의 최소 폭은 {0} {1}여야 합니다.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: '벽의 최소 높이는 {0} {1}여야 합니다.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    '벽 높이가 캔버스 높이보다 작습니다.',
  MAXIMUM_WALL_HEIGHT_KEY: '최대 벽 높이는 {0} {1}입니다 .',
  FINISHING_KEY: '완료',
  MIRROR_KEY: '미러',
  NATURAL_KEY: '내추럴',
  ROWS_KEY: '행',
  COLUMNS_KEY: '열',
  DEFAULT_WALL_SIZE_KEY: '기본 벽 사이즈',
  EDIT_KEY: '편집',
  TOP_KEY: '상단',
  BOTTOM_KEY: '하단'
};
